import React, { useMemo, useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import _, { set } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import HelloSign from "hellosign-embedded";
import Visa from "../../../assets/images/payment_options/visa.png";
import Mastercard from "../../../assets/images/payment_options/mastercard.png";
import Discover from "../../../assets/images/payment_options/discover.png";
import Amex from "../../../assets/images/payment_options/amex.png";
import Diners from "../../../assets/images/payment_options/diners.png";
import Select from "../../components/FormComponents/Select/Select";
import useResponsiveFontSize from "../useResponsiveFontSize";
import { usStates } from "../../utils/usStates";
import { countryList } from "../../utils/countryList";
import Autocomplete from "react-google-autocomplete";

import {
	useStripe,
	useElements,
	CardNumberElement,
	CardCvcElement,
	CardExpiryElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

const useOptions = () => {
	const fontSize = useResponsiveFontSize();
	const options = useMemo(
		() => ({
			showIcon: true,
			iconStyle: "solid",
			style: {
				base: {
					fontSize,
					iconColor: "#c4f0ff",
					width: "100%",
					color: "#424770",
					letterSpacing: "0.025em",
					border: "2px solid #ccc !important",
					borderRadius: "0",
					"::placeholder": {
						color: "#aab7c4",
					},
				},
				invalid: {
					color: "#9e2146",
				},
			},
		}),
		[fontSize]
	);

	return options;
};

const Field = ({
	label,
	id,
	type,
	placeholder,
	required,
	autoComplete,
	value,
	onChange,
	defaultValue,
	className,
}) => (
	<div className="FormRow">
		<input
			className={className}
			id={id}
			type={type}
			placeholder={placeholder}
			defaultValue={defaultValue}
			required={required}
			autoComplete={autoComplete}
			value={value}
			onChange={onChange}
		/>
	</div>
);

const accountTypeOptions = [
	<option value={"checking"} key={0}>
		Checking
	</option>,
	<option value={"savings"} key={1}>
		Savings
	</option>,
];

const accountHolderOptions = [
	<option value={"individual"} key={0}>
		Individual
	</option>,
	<option value={"company"} key={1}>
		Company
	</option>,
];

const Checkout = (props) => {
	const { helloSignCid, allowCreditCardPayments = false } = props;

	const helloSignClient = new HelloSign({ clientId: helloSignCid });

	const dispatch = useDispatch();

	const stripe = useStripe();
	const elements = useElements();
	const options = useOptions();

	const [shouldSign, setShouldSign] = useState(true);

	const [percentage, setPercentage] = useState(5);
	const [paymentLoading, setPaymentLoading] = useState(false);
	const [savePayment, setSavePayment] = useState(false);
	const [creditCard, setCreditCard] = useState(false);
	const [echeck, setEcheck] = useState(true);
	const [showSavedCard, setShowSavedCard] = useState(false);
	const [useSaveCard, setUseSaveCard] = useState(false);
	const [hideBank, setHideBank] = useState(false);
	const [saveCards, setSaveCards] = useState([]);
	const [saveCardId, setSaveCardId] = useState("");
	const [amount, setAmount] = useState([]);
	const [amountCreditCard, setAmountCreditCard] = useState([]);
	const [pay, setPay] = useState(null);
	const [paymentOption, setPaymentOption] = useState("annual");
	const [accountType, setAccountType] = useState("checking");
	const [accountHolder, setAccountHolder] = useState("individual");
	const [loading2, setLoading2] = useState(false);
	const [showBilling, setShowBilling] = useState(false);
	const [errorCard, setErrorCard] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const accountTypeRef = useRef();
	const accountHolderRef = useRef();
	const stateRef = useRef();
	const countryRef = useRef();

	//const [street, setStreet] = useState("");
	const [city, setCity] = useState("");
	const [state, setState] = useState("");
	const [zipCode, setZipCode] = useState("");
	const [line1, setLine1] = useState("");
	const [country, setCountry] = useState("");

	const apiGoogleKey = "AIzaSyDFJOYByneXFdBF5TLGVt_y1XnwOWtl5do";

	const [billingDetails, setBillingDetails] = useState({
		email: props.email,
		name: "",
	});

	const [bankDetails, setBankDetails] = useState({
		email: props.email,
		name: "",
	});

	const usStateOptions = usStates.map((state) => (
		<option value={state.value} key={state.value}>
			{state.name}
		</option>
	));

	const countryListOptions = countryList.map((country) => (
		<option value={country.value} key={country.value}>
			{country.name}
		</option>
	));

	const loading = useSelector((state) => state.LoadingCheckout);
	const signData = useSelector((state) => state.SignData);
	const renewalId = useSelector((state) => state.RenewalId);
	const renewalData = useSelector((state) => state.RenewalData);
	let history = useHistory();

	useEffect(() => {
		window.scrollTo(0, 0);
		if (signData.signed_url === "") {
			setShouldSign(false);
		} else {
			setShouldSign(true);
			signContract();
		}

		fetch(`/api/v2/payments/saved_cards`)
			.then((res) => res.json())
			.then((res) => {
				setSaveCards(res.saved_payment_options);
			});
	}, []);

	useEffect(() => {
		if (signData.signed_url === "") {
			setShouldSign(false);
		} else {
			setShouldSign(true);
			signContract();
		}
	}, [signData.signed_url]);

	useEffect(() => {
		if (props.email && !billingDetails.email) {
			setBillingDetails({ email: props.email });
		}
	}, [props.email]);

	useEffect(() => {
		if (renewalData) {
			setPercentage(renewalData.deductible_percentage);
			setAmount(renewalData.amount);
			setAmountCreditCard(renewalData.amount_for_credit_card);
			/* let value = renewalData.referral_available
				? _.get(renewalData, `amount.total_referral_10_discount`, "")
				: _.get(renewalData, `amount.annual_with_discount`, "");
			setPay(value); */
		}
	}, [renewalData]);

	const signContract = () => {
		showContract(signData.signed_url);
	};

	const showContract = (signingUrl) => {
		helloSignClient.open(signingUrl, {
			allowCancel: false,
			container: document.getElementById("hellosign-document-container"),
			skipDomainVerification: process.env.HELLOSIGN_PRODUCTION_MODE !== "true",
		});
	};

	helloSignClient.on("sign", () => {
		if (signData.next_url === "") {
			setShouldSign(false);
			dispatch({
				type: "SET_SIGN_DATA",
				payload: { signed_url: "", next_url: "" },
			});
		} else {
			setShouldSign(true);
			dispatch({
				type: "SET_LOADING_CHECKOUT",
				payload: true,
			});
			fetch(`${signData.next_url}`)
				.then((res) => res.json())
				.then((res) => {
					dispatch({
						type: "SET_SIGN_DATA",
						payload: res,
					});
				});
		}
	});

	const handleSubmit = async (event) => {
		// We don't want to let default form submission happen here,
		// which would refresh the page.
		event.preventDefault();
		setErrorCard(false);
		setLoading2(true);
		setPaymentLoading(true);

		if (!stripe || !elements) {
			setPaymentLoading(false);
			return;
		}

		let result;
		if (creditCard) {
			const card = elements.getElement(CardNumberElement);
			if (showBilling) {
				result = await stripe.createToken(card, {
					address_line1: line1,
					address_city: city,
					address_zip: zipCode,
					address_state: state,
					address_country: country,
				});
			} else {
				result = await stripe.createToken(card);
			}
		} else if (echeck) {
			result = await stripe.createToken("bank_account", {
				...bankDetails,
				country: "US",
				currency: "usd",
				account_holder_type: accountHolder,
			});
		} else {
			stripeTokenHandler("");
			return;
		}

		if (result.error) {
			setErrorMessage(result.error.message);
			setPaymentLoading(false);
			setErrorCard(true);
		} else {
			stripeTokenHandler(result.token);
		}
	};

	const stripeTokenHandler = async (token) => {
		let paymentData = {};
		if (creditCard) {
			paymentData = {
				card_token: token.id,
				payment_kind: paymentOption,
				save_payment_method: savePayment,
			};
		} else if (echeck) {
			paymentData = { bank_token: token.id, payment_kind: paymentOption };
		} else {
			paymentData = { paymentType: saveCardId, payment_kind: paymentOption };
		}

		const response = await fetch(`/api/v2/quotes/${renewalId}/payments`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(paymentData),
		})
			.then((response) => {
				if (!response.ok) {
					throw response;
				}
				if (response) {
					return response.json(); //we only get here if there is no error
				}
			})
			.then((json) => {
				history.push(`/v3/renewals/${renewalId}/react/complete`);
			})
			.catch((err) => {
				err.text().then((errorMessage) => {
					let errorText = JSON.parse(errorMessage);
					setErrorMessage(_.get(errorText, `error`, ""));
					setPaymentLoading(false);
					setErrorCard(true);
				});
			});

		setPaymentLoading(false);
		setLoading2(false);
	};

	return (
		<>
			{loading ? (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						paddingTop: "24px",
					}}
				>
					<Spinner
						animation="border"
						style={{ height: "4rem", width: "4rem" }}
					/>
				</div>
			) : (
				<>
					{shouldSign ? (
						<div className="sign-page">
							<div className="carCard miniCard">
								<h2> {signData.state_name} Requirement</h2>
								<ul>
									<li>
										{signData.state_name} law requires the completion of the
										following digitally signed documents. You will be asked to
										sign two documents, one covering the Physical Damage Policy
										and a second covering the Liability Policy.
									</li>
									<li>
										Please click the "CONTINUE" button to be guided through this
										quick and easy process.
									</li>
								</ul>
							</div>
							<div className="col-12 px-1 px-md-4 mt-8">
								<div
									id="hellosign-document-container"
									style={{ height: "90vh" }}
								/>
							</div>
						</div>
					) : (
						<div className="checkout general d-flex justify-content-center">
							<div className="otcontainer1 nopadding">
								<div className="col-12 otmt-2">
									<a
										className="d-flex"
										onClick={() =>
											history.push(`/v3/renewals/${renewalId}/react`)
										}
									>
										<div className="">
											<i className="bi bi-chevron-left i1"></i>
										</div>
										<div className="">
											<h4 className="ml-2 " style={{ color: "#00778a" }}>
												BACK TO REVIEW
											</h4>
										</div>
									</a>
								</div>
								<div className="col-12 px-1 px-md-4">
									<div className="col otmt-4 otmb-4">
										<h1 className="" style={{ color: "#00778a" }}>
											Checkout
										</h1>
									</div>
									<div className="col ">
										<h4 className="mb-2" style={{ color: "#979797" }}>
											1. Select your billing cycle
										</h4>
										<div className="heading">
											<div className="desc"></div>
										</div>
										<form className="">
											{/* 	





 */}

											<div className="d-flex justify-content-center flex-column flex-md-row my-5">
												<div className="custom-checkbox d-flex justify-content-center payment-option-radio pr-md-5 square">
													<input
														className=""
														type="radio"
														name="options"
														id="monthlyPayment"
														value={
															renewalData.referral_available
																? _.get(amount, `total_referral_discount`, "")
																: _.get(amount, `total`, "")
														}
														onChange={(event) => {
															setPay(event.target.value);
															setHideBank(true);
															setPaymentOption("monthly");
															setEcheck(false);
															setUseSaveCard(false);
															setShowSavedCard(true);
															setCreditCard(true);
														}}
													/>
													<div className="state d-flex flex-column align-items-center mt-sm-3">
														<div className="state__header h4 mb-3">
															MONTHLY PAYMENT
														</div>
														<p className="mb-2 state__type">&nbsp;</p>
														<div className="state__price">
															{renewalData.referral_available
																? formatter.format(
																		_.get(
																			amountCreditCard,
																			`total_referral_discount`,
																			""
																		) / 12
																  )
																: formatter.format(
																		_.get(amountCreditCard, `total`, "") / 12
																  )}
														</div>
														<div className="state__small px-3">
															Due now:{" "}
															{renewalData.referral_available
																? formatter.format(
																		_.get(
																			renewalData,
																			`amount_for_credit_card.initial_payment_amount_referral_discount`,
																			""
																		)
																  )
																: formatter.format(
																		_.get(
																			renewalData,
																			`amount_for_credit_card.initial_payment_amount`,
																			""
																		)
																  )}{" "}
															for first + last month
														</div>

														<div className="mb-2">
															<label htmlFor="monthlyPayment"></label>
														</div>
													</div>
												</div>

												<div className="custom-checkbox d-flex justify-content-center payment-option-radio pr-md-5 square mt-4 mt-md-0">
													<input
														className=""
														type="radio"
														name="options"
														id="anualPaymenteCheck"
														defaultChecked={true}
														value={
															renewalData.referral_available
																? _.get(
																		renewalData,
																		`amount.total_referral_10_discount`,
																		""
																  )
																: _.get(
																		renewalData,
																		`amount.annual_with_discount`,
																		""
																  )
														}
														onChange={(event) => {
															setPay(event.target.value);
															setHideBank(false);
															setPaymentOption("annual");
															setEcheck(true);
															setCreditCard(false);
															setShowSavedCard(false);
														}}
													/>
													<div className="state d-flex flex-column align-items-center mt-sm-3">
														<div className="state__header h4">
															ANNUAL PAYMENT
														</div>
														<p className="mt-2 mb-2 state__type">eCheck</p>

														<div className="state__price mt-0">
															{renewalData.referral_available
																? formatter.format(
																		_.get(
																			renewalData,
																			`amount.total_referral_10_discount`,
																			""
																		)
																  )
																: formatter.format(
																		_.get(
																			renewalData,
																			`amount.annual_with_discount`,
																			""
																		)
																  )}
														</div>
														<div className="pt-3 savings state__small">
															(
															{renewalData.referral_available
																? formatter.format(
																		parseInt(
																			_.get(renewalData, `amount.discount`, "")
																		) +
																			parseInt(
																				_.get(
																					renewalData,
																					`amount.referral_discount`,
																					""
																				)
																			)
																  )
																: formatter.format(
																		_.get(renewalData, `amount.discount`, "")
																  )}{" "}
															SAVINGS)
														</div>

														<div className="mb-2 mt-3">
															<label></label>
														</div>
													</div>
												</div>
												{(_.get(amount, `total`, "") < 10000 ||
													allowCreditCardPayments) && (
													<div className="custom-checkbox d-flex justify-content-center payment-option-radio square mt-4 mt-md-0">
														<input
															className=""
															type="radio"
															name="options"
															id="anualPaymentCreditCard"
															value={
																renewalData.referral_available
																	? _.get(
																			renewalData,
																			`amount_for_credit_card.total_referral_10_discount`,
																			""
																	  )
																	: _.get(
																			renewalData,
																			`amount_for_credit_card.annual_with_discount`,
																			""
																	  )
															}
															onChange={(event) => {
																setPay(event.target.value);
																setHideBank(true);
																setPaymentOption("annualCreditCard");
																setEcheck(false);
																setShowSavedCard(true);
																setCreditCard(true);
															}}
														/>
														<div
															className="state d-flex flex-column align-items-center mt-sm-3"
															htmlFor="anualPaymentCreditCard"
														>
															<div className="state__header h4">
																ANNUAL PAYMENT
															</div>
															<p className="mt-2 mb-2 state__type">
																Credit Card
															</p>

															<div className="state__price mt-0">
																{renewalData.referral_available
																	? formatter.format(
																			_.get(
																				renewalData,
																				`amount_for_credit_card.total_referral_10_discount`,
																				""
																			)
																	  )
																	: formatter.format(
																			_.get(
																				renewalData,
																				`amount_for_credit_card.annual_with_discount`,
																				""
																			)
																	  )}
															</div>
															<div className="pt-3 savings state__small">
																(
																{renewalData.referral_available
																	? formatter.format(
																			parseInt(
																				_.get(
																					renewalData,
																					`amount_for_credit_card.discount`,
																					""
																				)
																			) +
																				parseInt(
																					_.get(
																						renewalData,
																						`amount_for_credit_card.referral_discount`,
																						""
																					)
																				)
																	  )
																	: formatter.format(
																			_.get(
																				renewalData,
																				`amount_for_credit_card.discount`,
																				""
																			)
																	  )}{" "}
																SAVINGS)
															</div>

															<div className="mb-2 mt-3">
																<label></label>
															</div>
														</div>
													</div>
												)}
											</div>
											{/* 






 */}
										</form>
									</div>
									<form onSubmit={handleSubmit} className="payment-info">
										<div className="col-12">
											<h4 className="mb-2" style={{ color: "#979797" }}>
												2. Enter payment information
											</h4>
											<div className="heading">
												<div className="desc"></div>
											</div>
											{showSavedCard &&
												(!saveCards.length > 0 &&
												(_.get(amount, `total`, "") < 10000 ||
													allowCreditCardPayments) &&
												paymentOption === "annual"
													? null
													: saveCards.map((card, i) => (
															<div className="col-12 nopadding mb-4 mt-5 ml-md-3">
																<input
																	className=""
																	type="radio"
																	name="options"
																	id={`option${6 + i}`}
																	defaultChecked={false}
																	checked={useSaveCard}
																	onChange={() => {
																		setSaveCardId(card.id);
																		setCreditCard(false);
																		setEcheck(false);
																		setUseSaveCard(true);
																	}}
																/>
																<label
																	htmlFor={`option${6 + i}`}
																	className="t1 ml-3"
																>
																	<h2 className="mt-2 mt-md-0">
																		{card.payment_method_type} ending in{" "}
																		{card.last_four_digits} (exp{" "}
																		{card.expiration_date})
																	</h2>
																</label>
															</div>
													  )))}
											{!hideBank && (
												<div className="col-12 nopadding mb-4 mt-5 ml-md-3">
													<input
														className=""
														type="radio"
														name="options"
														id="option5"
														defaultChecked={true}
														checked={echeck}
														onChange={() => {
															setEcheck(true);
															setCreditCard(false);
															setUseSaveCard(false);
														}}
													/>
													<label htmlFor="option5" className="t1 ml-3">
														<h2 className="mt-2 mt-md-0">eCheck</h2>
													</label>
												</div>
											)}

											{(_.get(amount, `total`, "") < 10000 ||
												allowCreditCardPayments) &&
											paymentOption === "annual"
												? null
												: creditCard && (
														<div className="col-12 nopadding mb-4 mt-5 ml-md-3">
															<input
																className="ml-2"
																type="radio"
																name="options"
																id="option4"
																checked={creditCard}
																onChange={() => {
																	setCreditCard(true);
																	setEcheck(false);
																	setUseSaveCard(false);
																}}
															/>
															<label htmlFor="option4" className="t1 ml-3">
																<p className="mt-2 mt-md-0">
																	<img
																		className="pay-card ml-2"
																		src={Visa}
																		alt="..."
																	/>
																	<img
																		className="pay-card ml-2"
																		src={Mastercard}
																		alt="..."
																	/>
																	<img
																		className="pay-card ml-2"
																		src={Discover}
																		alt="..."
																	/>
																	<img
																		className="pay-card ml-2"
																		src={Amex}
																		alt="..."
																	/>
																	<img
																		className="pay-card ml-2"
																		src={Diners}
																		alt="..."
																	/>
																</p>
															</label>
														</div>
												  )}
											{errorCard && (
												<div className="alert alert-danger" role="alert">
													<p>{errorMessage}</p>
												</div>
											)}
											{creditCard && (
												<div className="row col mx-auto nopadding justify-content-md-center mb-3">
													<div className="col-md-10 col-12 nopadding">
														<label
															htmlFor="option5"
															className="p text-uppercase mt-3 mt-md-2"
														>
															Name on card
														</label>
														<Field
															label="Name"
															id="name"
															type="text"
															className="form-control"
															required
															autoComplete="name"
															value={billingDetails.name}
															onChange={(e) => {
																setBillingDetails({
																	...billingDetails,
																	name: e.target.value,
																});
															}}
														/>
													</div>
													<div className="col-md-10 col-12 nopadding">
														<label
															htmlFor="option6"
															className="p text-uppercase mt-3 mt-md-2"
														>
															Card number
														</label>
														<div className="form-control">
															<CardNumberElement options={options} />
														</div>
													</div>
													<div className="col-md-5 col-6 pl-0">
														<label
															htmlFor="option7"
															className="p text-uppercase mt-3 mt-md-2"
														>
															Expiration date
														</label>
														<div className="form-control">
															<CardExpiryElement options={options} />
														</div>
													</div>
													<div className="col-md-5 col-6 pr-0">
														<label
															htmlFor="option8"
															className="p text-uppercase mt-3 mt-md-2"
														>
															Security code
														</label>
														<div className="form-control">
															<CardCvcElement options={options} />
														</div>
													</div>
													{showBilling && (
														<div className="col-md-10 nopadding mt-2">
															<div className="otmb-1">
																<label
																	htmlFor="option5"
																	className="p text-uppercase mt-3 mt-md-2"
																>
																	Billing Address
																</label>
																<Autocomplete
																	apiKey={apiGoogleKey}
																	onPlaceSelected={(place) => {
																		let addressNumber = "";
																		place.address_components.filter((item) => {
																			switch (item.types[0]) {
																				case "street_number":
																					addressNumber = item.long_name;
																					break;
																				case "route":
																					setLine1(
																						addressNumber + " " + item.long_name
																					);
																					break;
																				case "locality":
																					setCity(item.long_name);
																					break;
																				case "country":
																					setCountry(item.short_name);
																					break;
																				case "postal_code":
																					setZipCode(item.long_name);
																					break;
																				default:
																					break;
																			}
																		});
																	}}
																	label="billingAddress"
																	id="billingAddress"
																	className="form-control"
																	required
																	autoComplete="billingAddress"
																	value={line1}
																	onChange={(e) => {
																		setLine1(e.target.value);
																	}}
																	options={{
																		types: ["address"],
																	}}
																/>
																{/* <Field
																	label="billingAddress"
																	id="billingAddress"
																	type="text"
																	className="form-control"
																	required
																	autoComplete="billingAddress"
																	value={line1}
																	onChange={(e) => {
																		setLine1(e.target.value);
																	}}
																/> */}
															</div>
															<div className="otmb-1">
																<label
																	htmlFor="option6"
																	className="p text-uppercase mt-3 mt-md-2"
																>
																	City
																</label>
																<Field
																	label="city"
																	id="city"
																	type="text"
																	className="form-control"
																	required
																	autoComplete="holderName"
																	value={city}
																	onChange={(e) => {
																		setCity(e.target.value);
																	}}
																/>
															</div>
															<div className="otmb-1">
																<Select
																	val={country}
																	setVal={setCountry}
																	label="Country"
																	options={countryListOptions}
																	classLabel="p text-uppercase"
																	classSelect="form-control"
																	validation="country"
																	required
																	ref={countryRef}
																	id="country"
																/>
															</div>
															{country === "US" && (
																<div className="otmb-1">
																	<Select
																		val={state}
																		setVal={setState}
																		label="State"
																		options={usStateOptions}
																		classLabel="p text-uppercase"
																		classSelect="form-control"
																		validation="state"
																		required
																		ref={stateRef}
																	/>
																</div>
															)}
															<div className="otmb-1">
																<label
																	htmlFor="option6"
																	className="p text-uppercase mt-3 mt-md-2"
																>
																	Zip Code
																</label>
																<Field
																	label="zipCode"
																	id="zipCode"
																	type="text"
																	className="form-control"
																	required
																	autoComplete="zipCode"
																	value={zipCode}
																	onChange={(e) => {
																		setZipCode(e.target.value);
																	}}
																/>
															</div>
														</div>
													)}
													<div className="col-12 col-md-11 d-flex otmt-1">
														<input
															id="option13"
															type="checkbox"
															className="col-1 big-check ml-md-2"
															checked={savePayment}
															onChange={() => setSavePayment(!savePayment)}
														/>
														<label
															htmlFor="option13"
															className="col-10 pl-md-0 mt-2 p"
														>
															Securely save this payment method for future
															purchase
														</label>
													</div>
													<div className="col-12 d-flex col-md-11">
														<input
															id="option14"
															type="checkbox"
															className="col-1 big-check ml-md-2"
															checked={!showBilling}
															onChange={() => setShowBilling(!showBilling)}
														/>
														<label
															htmlFor="option14"
															className="col-10 pl-md-0 mt-2 p"
														>
															Billing Address Same as Primary Driver Address
														</label>
													</div>
												</div>
											)}
											{echeck && (
												<div className="row col mx-auto nopadding justify-content-md-center mb-5">
													<div className="otmb-1 col-md-10 col-12">
														<label
															htmlFor="option5"
															className="p text-uppercase mt-3 mt-md-2"
														>
															Bank Name
														</label>
														<Field
															label="bankName"
															id="bankName"
															type="text"
															className="form-control"
															required
															autoComplete="name"
															value={billingDetails.bank_name}
															onChange={(e) => {
																setBankDetails({
																	...bankDetails,
																	bank_name: e.target.value,
																});
															}}
														/>
													</div>
													<div className="otmb-1 col-md-10 col-12">
														<Select
															val={accountType}
															setVal={setAccountType}
															label="Account Type"
															selectLabel="Account Type"
															options={accountTypeOptions}
															classLabel="p text-uppercase mt-3 mt-md-2"
															classSelect="form-control"
															validation="lien"
															ref={accountTypeRef}
														/>
													</div>
													<div className="otmb-1 col-md-10 col-12">
														<label
															htmlFor="option6"
															className="p text-uppercase mt-3 mt-md-2"
														>
															Account Holder Name
														</label>
														<Field
															label="holderName"
															id="holderName"
															type="text"
															className="form-control"
															required
															autoComplete="holderName"
															value={billingDetails.account_holder_name}
															onChange={(e) => {
																setBankDetails({
																	...bankDetails,
																	account_holder_name: e.target.value,
																});
															}}
														/>
													</div>
													<div className="otmb-1 col-md-10 col-12">
														<Select
															val={accountHolder}
															setVal={setAccountHolder}
															label="Account Holder Type"
															selectLabel="Account Holder Type"
															options={accountHolderOptions}
															classLabel="p text-uppercase mt-3 mt-md-2"
															classSelect=" form-control"
															validation="lien"
															ref={accountHolderRef}
														/>
													</div>
													<div className="otmb-1 col-md-10 col-12">
														<label
															htmlFor="option6"
															className="p text-uppercase mt-3 mt-md-2"
														>
															Bank Routing Number
														</label>
														<Field
															label="routingNumber"
															id="routingNumber"
															type="text"
															className="form-control"
															required
															autoComplete="routingNumber"
															value={billingDetails.routing_number}
															onChange={(e) => {
																setBankDetails({
																	...bankDetails,
																	routing_number: e.target.value,
																});
															}}
														/>
													</div>
													<div className="otmb-1 col-md-10 col-12">
														<label
															htmlFor="option6"
															className="p text-uppercase mt-3 mt-md-2"
														>
															Account Number
														</label>
														<Field
															label="accountNumber"
															id="accountNumber"
															type="text"
															className="form-control"
															required
															autoComplete="accountNumber"
															value={billingDetails.account_number}
															onChange={(e) => {
																setBankDetails({
																	...bankDetails,
																	account_number: e.target.value,
																});
															}}
														/>
													</div>
												</div>
											)}
										</div>
										<div className="heading mx-4">
											<div className="desc"></div>
										</div>
										<div className="mt-5 d-flex justify-content-center">
											<div className="col-md-10">
												<div className="card c19 mb-5">
													<p className="t7 offer-ord1 col-12 mt-5 text-center">
														{paymentOption === "monthly" ? null : "Billed Now"}
													</p>

													<h1
														className="text-center"
														style={{ color: "#00778a" }}
													>
														{paymentOption !== "monthly" ? (
															<>
																{echeck
																	? formatter.format(
																			renewalData.referral_available
																				? _.get(
																						renewalData,
																						`amount.total_referral_10_discount`,
																						""
																				  )
																				: _.get(
																						renewalData,
																						`amount.annual_with_discount`,
																						""
																				  )
																	  )
																	: formatter.format(
																			renewalData.referral_available
																				? _.get(
																						renewalData,
																						`amount_for_credit_card.total_referral_10_discount`,
																						""
																				  )
																				: _.get(
																						renewalData,
																						`amount_for_credit_card.annual_with_discount`,
																						""
																				  )
																	  )}
															</>
														) : null}
														{paymentOption === "monthly" && (
															<>
																Pay{" "}
																{echeck ? (
																	<>
																		{renewalData.referral_available
																			? formatter.format(
																					_.get(
																						renewalData,
																						`amount.initial_payment_amount_referral_discount`,
																						""
																					)
																			  )
																			: formatter.format(
																					_.get(
																						renewalData,
																						`amount.initial_payment_amount`,
																						""
																					)
																			  )}
																	</>
																) : (
																	<>
																		{renewalData.referral_available
																			? formatter.format(
																					_.get(
																						renewalData,
																						`amount_for_credit_card.initial_payment_amount_referral_discount`,
																						""
																					)
																			  )
																			: formatter.format(
																					_.get(
																						renewalData,
																						`amount_for_credit_card.initial_payment_amount`,
																						""
																					)
																			  )}
																	</>
																)}{" "}
																now for your first + last month
															</>
														)}
													</h1>

													{paymentOption === "monthly" && (
														<>
															<p
																className="col font-weight-bold otmb-2 otmt-1 text-center"
																style={{ color: "#00778a" }}
															>
																We'll automatically charge your card{" "}
																{echeck ? (
																	<>
																		{renewalData.referral_available
																			? formatter.format(
																					_.get(
																						renewalData,
																						`amount.monthly_payment_referral_discount`,
																						""
																					)
																			  )
																			: formatter.format(
																					_.get(
																						renewalData,
																						`amount.monthly_payment`,
																						""
																					)
																			  )}
																	</>
																) : (
																	<>
																		{renewalData.referral_available
																			? formatter.format(
																					_.get(
																						renewalData,
																						`amount_for_credit_card.monthly_payment_referral_discount`,
																						""
																					)
																			  )
																			: formatter.format(
																					_.get(
																						renewalData,
																						`amount_for_credit_card.monthly_payment`,
																						""
																					)
																			  )}
																	</>
																)}{" "}
																per month for the next 10 months starting on{" "}
																{moment().add(1, "months").format("LL")}
															</p>
														</>
													)}

													<div className="col-12 d-flex ml-3 mt-3">
														<input
															id="option10"
															type="checkbox"
															className="col-1 big-check ml-md-2"
															required
														/>
														<label
															htmlFor="option10"
															className="col-10 pl-md-0 mt-2 p"
														>
															I have read and agree to the OpenTrack{" "}
															<a
																href="https://opentrack.com/disclaimers_disclosures.html"
																target="_blank"
																className="danger-text"
															>
																Disclaimers & Disclosures
															</a>
															. By checking this box, I agree my electronic
															signature is the legal equivalent of my
															manual/handwritten signature on these Disclaimers
															& Disclosures.
														</label>
													</div>
													<div className="col-12 d-flex ml-3 mb-3">
														<input
															id="option11"
															type="checkbox"
															className="col-1 big-check ml-md-2"
															required
														/>
														<label
															htmlFor="option11"
															className="col-10 pl-md-0 mt-2 p"
														>
															I authorize OpenTrack to send me text messages
														</label>
													</div>
													{paymentLoading ? (
														<div
															style={{
																display: "flex",
																justifyContent: "center",
																paddingTop: "24px",
																paddingBottom: "24px",
															}}
														>
															<Spinner
																animation="border"
																style={{ height: "4rem", width: "4rem" }}
															/>
														</div>
													) : (
														<button
															type="submit"
															className="btn btn-lg btn2 mb-5 mt-1 mx-auto"
															disabled={paymentLoading}
														>
															SUBMIT PAYMENT
														</button>
													)}
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					)}
				</>
			)}
		</>
	);
};

export default Checkout;
